import { Card } from "../../../../components/Card";

type Props = {
  hcp: string;
  objection: string;
  personality: string;
  callFocusText?: string;
};

export function InsightsCallDetailsCard({ hcp, objection, personality, callFocusText }: Props) {
  return (
    <Card className="flex flex-col gap-3">
      <div className="text-sm font-semibold text-text-primary">Call Details</div>
      <div className="flex gap-1.5">
        <div className="flex-1 bg-[#f4f4f5] rounded-md p-2 flex flex-col gap-0.5">
          <span className="text-xs text-[#71717a] leading-[1.3]">HCP</span>
          <span className="text-xs font-semibold text-[#242424] leading-[1.3]">{hcp}</span>
        </div>
        <div className="flex-1 bg-[#f4f4f5] rounded-md p-2 flex flex-col gap-0.5">
          <span className="text-xs text-[#71717a] leading-[1.3]">Objection Level</span>
          <span className="text-xs font-semibold text-[#242424] leading-[1.3]">{objection}</span>
        </div>
      </div>
      <div className="flex gap-1.5">
        <div className="flex-1 bg-[#f4f4f5] rounded-md p-2 flex flex-col gap-0.5">
          <span className="text-xs text-[#71717a] leading-[1.3]">Personality Type</span>
          <span className="text-xs font-semibold text-[#242424] leading-[1.3]">{personality}</span>
        </div>
        {callFocusText && (
          <div className="flex-1 bg-[#f4f4f5] rounded-md p-2 flex flex-col gap-0.5">
            <span className="text-xs text-[#71717a] leading-[1.3]">Call Focus</span>
            <span className="text-xs font-semibold text-[#242424] leading-[1.3]">{callFocusText}</span>
          </div>
        )}
      </div>
    </Card>
  );
}
